import React, { useContext } from 'react'
import { useNavigate } from 'react-router-dom'
import { ItemSelectableWithOptions } from '../../ItemSelectable/ItemSelectableWithOptions';
import { t } from 'i18next';
import SectorsManagementContext from '../../../context/SectorsContext/SectorsManagementContext';

export const ListOfSectors = ({ sector, openWarningModalToDelete }) => {
    const navigate = useNavigate();

    const { setSectorsData } = useContext(SectorsManagementContext);

    const goToEditSector = async () => {
        await setSectorsData(sector);
        navigate(`/settings/entityManagment/sectorMaganagement/edit/${sector.sectorId}`);
    }

    const optionsOfAreas = [
        {
            name: `${t('EDIT')} ${t('SECTOR')}`,
            icon: 'edit-black-icon.svg',
            onClick: () => goToEditSector(sector),
        },
        {
            name: `${t('DELETE')} ${t('SECTOR')}`,
            icon: 'trash-bin.svg',
            onClick: () => openWarningModalToDelete(sector),
        },
    ]

    return (
        <>
            <ItemSelectableWithOptions options={optionsOfAreas} idPopover={`sectorEdit-${sector.sectorId}`}>
                <div>
                    <p className='m-0 param-section-title'>{`${sector.sectorName}`}</p>
                </div>
            </ItemSelectableWithOptions>
        </>

    )
}
